import apiConfig from "./ApiConfig";
import ApiRequest from "./ApiRequest";

export const bulkUploadModel = (endpoint) => {
    const bulkUpload = async (file, dryRun = false) => {
        const formData = new FormData();
        formData.append('file', file, file.name);
        return await ApiRequest.setMultipart(
            `${endpoint}bulk-upload${dryRun ? '?dry_run=true' : ''}`,
            'POST',
            formData,
        );
    };

    const downloadTemplate = async () => {
        const token = localStorage.getItem('super_token') || localStorage.getItem('token');
        const response = await fetch(`${apiConfig.base_url}${endpoint}bulk-template`, {
            headers: {
                Authorization: token ? `Bearer ${token}` : null,
            },
        });
        if (!response.ok) {
            let errorMessage = 'Failed to download template';
            try {
                const err = await response.json();
                errorMessage = err?.error_message || err?.message || errorMessage;
            } catch (e) {
                // ignore
            }
            throw new Error(errorMessage);
        }
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `${endpoint.replace(/\/$/, '').split('/').pop()}_bulk_template.xlsx`;
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
    };

    return { bulkUpload, downloadTemplate };
};

export default { bulkUploadModel };
